import { agentTypes } from "@agent/agent-types.di";
import { AgentInMemoryDatasource } from "@agent/data/datasources/agent-in-memory.datasource";
import { AgentDatasource } from "@agent/data/datasources/agent.datasource";
import { AgentMapper } from "@agent/data/mappers/agent.mapper";
import { PathogenTypeEnumMapper } from "@agent/data/mappers/pathogen-type-enum.mapper";
import { AgentImplRepository } from "@agent/data/repositories/agent.impl-repository";
import type { AgentRepository } from "@agent/domain/repositories/agent.repository";
import { AgentGetAllUseCase } from "@agent/domain/usecases/agent-get-all.usecase";
import { PathogenTypeGetAllUseCase } from "@agent/domain/usecases/pathogen-type-get-all.usecase";
import { AgentFilterViewmodel } from "@agent/presentation/components/agent-filter/agent-filter.viewmodel";
import { AgentPageViewmodel } from "@agent/presentation/pages/agent/agent-page.viewmodel";
import { AgentSearchMobileViewmodel } from "@agent/presentation/pages/agent/mobile/search/agent-search-mobile.viewmodel";
import { DiModuleBuilder } from "@iot-platform/core";
import { ContainerModule } from "inversify";

const webAgentModule = new DiModuleBuilder();

webAgentModule.registerSubModules(() => ({
    datasources: new ContainerModule(({ bind }) => {
        bind(AgentDatasource).toSelf();
        bind(AgentInMemoryDatasource).toSelf();
    }),
    mappers: new ContainerModule(({ bind }) => {
        bind(AgentMapper).toSelf();
        bind(PathogenTypeEnumMapper).toSelf();
    }),
    repositories: new ContainerModule(({ bind }) => {
        bind<AgentRepository>(agentTypes.repositories.AgentRepository).to(
            AgentImplRepository,
        );
    }),
    useCases: new ContainerModule(({ bind }) => {
        bind(AgentGetAllUseCase).toSelf();
        bind(PathogenTypeGetAllUseCase).toSelf();
    }),
    viewModels: new ContainerModule(({ bind }) => {
        bind(AgentFilterViewmodel).toSelf();
        bind(AgentPageViewmodel).toSelf();
        bind(AgentSearchMobileViewmodel).toSelf();
    }),
}));

webAgentModule.registerModule();

export { webAgentModule };
